import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../../../../shared/components/core-ui/modal/modal.component';
import Button, {
  ButtonType
} from '../../../../../shared/components/core-ui/button/button.component';
import { BlogUiModel } from '../../../../../shared/ui-models/blog.ui-model';

export interface DeleteBlogModalProps {
  config: {
    showModal: boolean;
  };
  data: {
    blog: BlogUiModel | undefined;
  };
  eventHandlers: {
    cancelHandler: () => void;
    deleteBlogHandler: (blog: BlogUiModel) => void;
  };
}

export const DeleteBlogModal: React.FC<DeleteBlogModalProps> = ({
  config,
  data,
  eventHandlers
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      config={{ showModal: config.showModal, fullScreen: false, showClose: true }}
      eventHandlers={{ closeModalHandler: eventHandlers.cancelHandler }}
    >
      <div className="flex flex-col items-center gap-[2rem] p-[2rem]">
        <div className="text-[2rem] font-bold text-primary-500">
          {t('BLOG_MODULE.LIST_CONTAINER.DELETE_MODAL.TITLE')}
        </div>
        <div className="text-center text-[1.6rem]">
          {t('BLOG_MODULE.LIST_CONTAINER.DELETE_MODAL.CONFIRMATION')}
          <span className="ml-[0.5rem] font-bold">{data.blog?.header}</span>
        </div>
        <div className="flex items-center gap-[1rem]">
          <Button type={ButtonType.gray} onClick={eventHandlers.cancelHandler}>
            {t('BLOG_MODULE.LIST_CONTAINER.DELETE_MODAL.CANCEL')}
          </Button>
          <Button
            type={ButtonType.danger}
            onClick={() => {
              if (data.blog) {
                eventHandlers.deleteBlogHandler(data.blog);
              }
            }}
          >
            {t('BLOG_MODULE.LIST_CONTAINER.DELETE_MODAL.CONFIRM')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteBlogModal;
